import React, { useState, useEffect } from 'react'

import { useSelector } from 'react-redux'
import { ModeTypes, Events, UserStatus } from 'common/Enums'
import EventEmitter from 'common/EventEmitter'
import { ReactComponent as AvailableIcon } from 'assets/svg/shared/available.svg'
import { ReactComponent as UnavailableIcon } from 'assets/svg/shared/do_not_disturb.svg'
import { RegistererState, TransportState } from 'sip.js'
import { useTranslation } from 'react-i18next'

export const AppMode = () => {
    const { t } = useTranslation()
    const [availableText, setStatusText] = useState('')
    const [iconAvailableState, setStatusIcon] = useState(false)
    const extension = useSelector((state) => state.profile.data.extension_number)
    const { transportStatus, registeredStatus } = useSelector((state) => state.userAgent)
    const { mode } = useSelector((state) => state.settings)

    const setStatus = (status, iconState) => {
        setStatusText(t(`connectionstate.${status}`))
        setStatusIcon(iconState)
        EventEmitter.emit(Events.UserStatus, { status })
    }

    useEffect(() => {
        setStatusIcon(mode === ModeTypes.Available)
    }, [mode])

    useEffect(() => {
        switch (transportStatus) {
            case TransportState.Disconnected:
                setStatus(UserStatus.Disconnected, false)
                break
            case TransportState.Connected:
                if (!registeredStatus) {
                    setStatus(UserStatus.Connected, false)
                    break
                }

                switch (registeredStatus) {
                    case RegistererState.Registered:
                        setStatus(UserStatus.Available, true)
                        break
                    case RegistererState.Unregistered:
                        setStatus(UserStatus.Unavailable, false)
                        break
                    case RegistererState.Registering:
                        setStatus(UserStatus.Registering, false)
                        break
                    case RegistererState.Terminated:
                        setStatus(UserStatus.Unavailable, false)
                        break
                    default:
                        if (mode === ModeTypes.Unavailable) {
                            setStatus(UserStatus.Unavailable, false)
                        }
                }
                break
            case TransportState.Connecting:
                setStatus(UserStatus.Connecting, false)
                break
            default:
                setStatusText('')
                setStatusIcon(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [transportStatus, registeredStatus, mode, t])

    return (
        <>
            {extension ? (
                <div className="d-flex align-items-center showIn">
                    {extension && <span className="app__header__text-extension">{extension}</span>}
                    {iconAvailableState ? (
                        <AvailableIcon width={12} height={12} />
                    ) : (
                        <UnavailableIcon width={12} height={12} />
                    )}
                    <span className="app__header__text-mode">{availableText}</span>
                </div>
            ) : (
                <div className="skeleton skeleton--dark"></div>
            )}
        </>
    )
}
